import 'normalize.css/normalize.css' // a modern alternative to CSS resets
import './assets/css/reset.css'
import "vue-happy-scroll/docs/happy-scroll.css";

import Vue from 'vue'

import Element from 'element-ui'
// import 'element-ui/lib/theme-chalk/index.css';
// ElementUI提供的fade/zoom等动画
import 'element-ui/lib/theme-chalk/base.css';
// 自定义ElementUI主题
import './styles/element-variables.scss'
import '@/styles/index.scss' // global css
import './assets/icon/iconfont.css'

import App from './App'
import router from './router'
import store from './store'

// 鼠标/手指滑动触摸插件
var VueTouch = require('vue-touch')
VueTouch.registerCustomEvent('dbtap', {
    type: 'tap',
    taps: 2
})
Vue.use(VueTouch, {
    name: 'v-touch'
})

import './plugins/api.js'

import VueLazyload from 'vue-lazyload'
Vue.use(VueLazyload)

import i18n from './lang' // internationalization
import './icons' // icon
import './permission' // permission control
import './utils/error-log' // error log

import * as filters from './filters' // global filters
// 按钮权限指令
import permission from '@/directive/permission'
import ptzControl from '@/directive/ptz-control'
// Vue.directive('focus', permission)
Vue.use(permission)
Vue.use(ptzControl)

/**
 * If you don't want to use mock-server
 * you want to use MockJs for mock api
 * you can execute: mockXHR()
 *
 * Currently MockJs will be used in the production environment,
 * please remove it before going online ! ! !
 */
/* if (process.env.NODE_ENV === 'production') {
    const { mockXHR } = require('../mock')
    mockXHR()
} */

Vue.use(Element, {
    size: 'small',
    // zIndex: 10000,
    i18n: (key, value) => i18n.t(key, value)
})

// register global utility filters
Object.keys(filters).forEach(key => {
    Vue.filter(key, filters[key])
})

Vue.config.productionTip = false

new Vue({
    el: '#app',
    router,
    store,
    i18n,
    render: h => h(App)
})